<template>
  <div ref="countdownRef" class="countdown-parallax-container">
    <div class="parallax-background">
      <div class="overlay"></div>
    </div>
    <br><br><br><br><br><br>
    <div class="countdown-wrapper">
      <p class="text-corinthia">Solo faltan</p>

      <div class="countdown">
        <div class="item"><span class="fa-font">{{ days }}</span><label>DÍAS</label></div>
        <div class="item"><span class="fa-font">{{ hours }}</span><label>HORAS</label></div>
        <div class="item"><span class="fa-font">{{ minutes }}</span><label>MINUTOS</label></div>
        <div class="item"><span class="fa-font">{{ seconds }}</span><label>SEGUNDOS</label></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'contador-vue',
  setup() {
    const countdownRef = ref(null);
    const days = ref('00');
    const hours = ref('00');
    const minutes = ref('00');
    const seconds = ref('00');
    let interval;

    const updateCountdown = () => {
      const eventDate = new Date('2025-07-11T18:00:00');
      const now = new Date();
      const diff = eventDate - now;

      if (diff <= 0) {
        days.value = hours.value = minutes.value = seconds.value = '00';
        clearInterval(interval);
        return;
      }

      days.value = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(2, '0');
      hours.value = String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, '0');
      minutes.value = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, '0');
      seconds.value = String(Math.floor((diff / 1000) % 60)).padStart(2, '0');
    };

    const animateCountdown = () => {
      const tl = gsap.timeline();
      tl.from('.parallax-background', {
        scale: 1.05, // sutil zoom
        opacity: 0,
        duration: 1.5,
        ease: 'power2.out'
      });
      tl.from('.ornamento-top', {
        opacity: 0,
        rotate: 360,
        duration: 1.2,
        ease: 'power2.out'
      }, "-=1");
      tl.from('.text-corinthia', {
        opacity: 0,
        y: 40,
        duration: 1,
        ease: 'power2.out'
      }, "-=0.8");
      tl.from('.item', {
        opacity: 0,
        y: 30,
        stagger: 0.2,
        duration: 1,
        ease: 'power2.out'
      }, "-=0.6");
    };

    onMounted(async () => {
      await nextTick();
      updateCountdown();
      interval = setInterval(updateCountdown, 1000);

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateCountdown();
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      if (countdownRef.value) observer.observe(countdownRef.value);
    });

    onBeforeUnmount(() => {
      clearInterval(interval);
    });

    return { countdownRef, days, hours, minutes, seconds };
  }
};
</script>

<style scoped>
.countdown-parallax-container {
  position: relative;
  min-height: 50vh;
  overflow: hidden;
}

.parallax-background {
  background-image: url('@/assets/portada-111.webp');
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.countdown-wrapper {
    position: relative;
    z-index: 1;
    color: white;
    text-align: center;
    padding: 60px 20px;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .ornamento-top,
  .ornamento-bottom {
    width: 40px;
    margin: 20px auto;
    display: block;
  }
  
  .text-corinthia {
    font-family: 'corinthia', cursive;
    font-size: 54px;
    margin: 10px 0;
  }
  
  .countdown {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin: 20px 0;
    backdrop-filter: blur(3px);
  }
  
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .fa-font {
    font-family: 'Jost', 'Playfair Display', sans-serif;
    font-size: 32px;
    color: white;
  }
  
  .item label {
    font-family: 'padres';
    font-size: 12px;
    letter-spacing: 2px;
    color: white;
    margin-top: 5px;
  }
  
  .btn-calendar {
    display: inline-block;
    background: white;
    color: #333;
    font-family: 'padres';
    padding: 10px 20px;
    border-radius: 4px;
    margin-top: 10px;
    letter-spacing: 2px;
    text-decoration: none;
    font-size: 13px;
    transition: background 0.3s ease;
  }
  
  .btn-calendar i {
    margin-right: 5px;
  }
  
  .btn-calendar:hover {
    background: #eaeaea;
  }
  </style>
  